import { Component, EventEmitter, OnInit, OnDestroy } from "@angular/core"
import { Subscription } from "rxjs"
import { CHNode } from "../../models/node.model"
import { BrowsingService } from "../../services/browsing.service"

@Component({
    selector: "app-disciplines",
    templateUrl: "./disciplines.component.html",
    styleUrls: ["./disciplines.component.less"],
})
export class DisciplinesComponent implements OnInit, OnDestroy {
    chNodes: CHNode[]
    subscriptions: Subscription[] = []
    grades = [
        { title: "PreK", slug: "prek" },
        { title: "Early Elementary", slug: "early-elementary" },
        { title: "Upper Elementary", slug: "upper-elementary" },
        { title: "Middle School", slug: "middle-school" },
        { title: "High School", slug: "high-school" },
    ]
    public gtmBrowseBySubject = "gtm-homepage-browse-by-subject"
    public gtmBrowseByGrade = "gtm-homepage-browse-by-grade"

    constructor(private browsingService: BrowsingService) {}

    ngOnInit() {
        this.subscriptions.push(
            this.browsingService.tree.subscribe(
                (chNodes: CHNode[]) => (this.chNodes = chNodes),
                (error) => console.error(`[CUSTOM Error]${error}`)
            )
        )
    }

    ngOnDestroy() {
        this.subscriptions.map((subscription) => subscription.unsubscribe())
    }
}
